import { receiptBenefits } from '@pxtra-client-lib-legacy';
import { BenefitEnum } from '@pxtra-client-lib-legacy/gen';
import { useTranslation } from 'react-i18next';
import { useStore } from '../../../../hooks/useStore';
import { BenefitKey } from '../../../../lib/components/compound/dataDisplay';
import Util from '../../../../misc/util';
import { useOptions, UseOptionsArgs } from './useOptions';
import { usePaymentData } from '../../../../queries/company';

type ReceiptBenefits = (typeof receiptBenefits)[number];

export const useBenefitFilter = () => {
  const { companyStore } = useStore();
  const { data: paymentData } = usePaymentData(companyStore.company?.id ?? '');
  return {
    isCompanyEnabled: (b: BenefitKey) => {
      return paymentData?.booked_benefits?.includes(b) ?? false;
    },
    isReceiptEnabled: (b: BenefitKey) => receiptBenefits.includes(b as ReceiptBenefits)
  };
};

//Hook//////////////////////////////////////////////////////////////////

export const useBenefitOptions = ({ deps, ...args }: UseOptionsArgs<BenefitKey>) => {
  const { t } = useTranslation();
  const { companyStore } = useStore();
  return useOptions<BenefitKey>(
    {
      map: (key) => ({
        value: key as string,
        text: t(`benefits:${key as BenefitEnum}`)
      }),
      getItems: {
        async: async () => {
          await companyStore.fetchBenefitSettings();
          return Util.getKeys(companyStore.benefitSettings) as BenefitKey[];
        }
      },
      filter: args.filter,
      isItemHidden: args.isItemHidden,
      prepend: args.prepend,
      append: args.append
    },
    deps
  );
};
